import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import type { Components } from 'react-markdown';

const components: Components = {
  h1: ({ children }) => (
    <h1 className="text-base font-semibold text-white mt-5 mb-2 first:mt-0">{children}</h1>
  ),
  h2: ({ children }) => (
    <h2 className="text-sm font-semibold text-white mt-4 mb-1.5 first:mt-0">{children}</h2>
  ),
  h3: ({ children }) => (
    <h3 className="text-sm font-medium text-gray-200 mt-3 mb-1 first:mt-0">{children}</h3>
  ),
  p: ({ children }) => (
    <p className="text-sm text-gray-200 leading-relaxed mb-3 last:mb-0">{children}</p>
  ),
  ul: ({ children }) => (
    <ul className="mb-3 last:mb-0 space-y-1 pl-4">{children}</ul>
  ),
  ol: ({ children }) => (
    <ol className="mb-3 last:mb-0 space-y-1 pl-4 list-decimal">{children}</ol>
  ),
  li: ({ children }) => (
    <li className="text-sm text-gray-200 leading-relaxed list-disc marker:text-gray-600">{children}</li>
  ),
  strong: ({ children }) => (
    <strong className="font-semibold text-white">{children}</strong>
  ),
  em: ({ children }) => (
    <em className="italic text-gray-300">{children}</em>
  ),
  code: ({ children, className }) => {
    const isBlock = Boolean(className?.includes('language-'));
    if (isBlock) {
      return (
        <pre className="rounded-lg border border-gray-800 bg-gray-950 p-3 text-xs text-gray-300 overflow-x-auto mb-3 last:mb-0 font-mono leading-relaxed">
          <code>{children}</code>
        </pre>
      );
    }
    return (
      <code className="rounded border border-gray-800 bg-gray-900 px-1 py-0.5 text-xs text-gray-300 font-mono">
        {children}
      </code>
    );
  },
  blockquote: ({ children }) => (
    <blockquote className="border-l-2 border-gray-700 pl-3 italic text-gray-400 mb-3 last:mb-0">
      {children}
    </blockquote>
  ),
  hr: () => <hr className="border-gray-800 my-4" />,
  table: ({ children }) => (
    <div className="overflow-x-auto mb-3 last:mb-0">
      <table className="w-full text-xs border-collapse">{children}</table>
    </div>
  ),
  th: ({ children }) => (
    <th className="border border-gray-800 px-3 py-2 text-left text-gray-400 bg-gray-900 font-medium">{children}</th>
  ),
  td: ({ children }) => (
    <td className="border border-gray-800 px-3 py-2 text-gray-300">{children}</td>
  ),
};

interface PortalMarkdownProps {
  content: string;
  className?: string;
}

export function PortalMarkdown({ content, className }: PortalMarkdownProps) {
  return (
    <div className={className}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
        {content}
      </ReactMarkdown>
    </div>
  );
}
